//import axios from 'axios'
import api from './axiosConfig'

export const deviceApi = {

    searchDevices({ search, page, perPage, customerId, supplierPlanId } = {}) {
        return api
            .get('/device/search?search=' + search + '&customerId='+ customerId + '&supplierplanid=' + supplierPlanId +'&page=' + page + '&perPage=' + perPage)
            .then((response) => {
                return response.data
            })
    },

    getDevicesReport({ search, customerId, supplierPlanId } = {}) {
        return api
            .get('/device/exportdevicesexcel', {
                params: {
                    search,
                    customerId,
                    supplierPlanId
                },
                responseType: 'blob'
            })
            .then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Devices report.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();

                return true;
            })
    },

    getDevice({ id } = {}) {
        return api
            .get('/device/get?id=' + id)
            .then((response) => {
                return response.data
            })
    },
    getDeviceTelemetryValues({ id } = {}) {
        return api
            .get('Device/getdevicetelemetryvalues?id=' + id)
            .then((response) => {
                return response.data
            })
    },

    getDeviceComplete({ id } = {}) {
        return api
            .get('/device/GetWithLastMessages?id=' + id)
            .then((response) => {
                return response.data
            })
    },

    updateDevice({ id, chassis, note, groupId, installConfigurationModelId, hourmeterOffset, odometerOffset, dbcId } = {}) {
        return api
            .put('/device/update', { id, chassis, note, groupId, installConfigurationModelId, hourmeterOffset, odometerOffset, dbcId }, {})
            .then((response) => {
                return response.data
            })
    },

    createDevice({ modemId, modelId, customerId } = {}) {
        return api
            .post('/device/createdevice', { id: modemId, modelId, customerId }, {})
            .then((response) => {
                return response.data
            })
    },

    createDeviceBulk({ ids, modelId, customerId } = {}) {
        return api
            .post('/device/createdevicebulk', { ids, modelId, customerId }, {})
            .then((response) => {
                return true;
            })
    },

    updateDeviceBulk({ ids, customerId } = {}) {
        return api
            .put('/device/updatedevicebulk', { ids, customerId }, {})
            .then((response) => {
                return true;
            })
    },

    installDeviceBulk({ devices } = {}) {
        return api
            .put('/device/installdevicebulk', { devices }, {})
            .then((response) => {
                return true;
            })
    },

    searchDeviceModels({ search, page, perPage } = {}) {
        return api
            .get('/device/searchdevicemodels?search=' + search + '&page=' + page + '&perPage=' + perPage)
            .then((response) => {
                return response.data
            })
    },

    searchTelemetry({ deviceId, page, perPage, start, end } = {}) {
        return api
            .get('/device/searchtelemetry', {
                params: { deviceId, page, perPage, start, end }
            })
            .then((response) => {
                return response.data
            })
    },

    getPlanActivationStatus({ deviceId } = {}) {
        return api
            .get('/plan/getactivation?deviceId=' + deviceId)
            .then((response) => {
                return response.data
            })
    },

    activateDevicePlan({ deviceId } = {}) {
        return api
            .post('/plan/activateplan', { deviceId }, {})
            .then((response) => {
                return response.data
            })
    },

    searchDeviceGroups({ search, customerId, page, perPage }) {
        return api
            .get(`/device/searchdevicegroups?search=${search}&customerId=${customerId}&page=${page}&perPage=${perPage}`)
            .then((response) => {
                return response.data
            })
    },

    searchDBCs({ search,  page, perPage }) {
        return api
            .get(`/DBC/search?search=${search}&page=${page}&perPage=${perPage}`)
            .then((response) => {
                return response.data
            })
    },

    createDeviceGroup({ name, description, endpoint, endpointToken, customerId } = {}) {
        customerId = customerId == '' ? null : customerId
        return api
            .post('/device/creategroup', { name, description, endpoint, endpointToken, customerId }, {})
            .then((response) => {
                return response.data
            })
    },

    updateDeviceGroup({ id, name, description, endpoint, endpointToken } = {}) {
        return api
            .put('/device/updategroup', { id, name, description, endpoint, endpointToken }, {})
            .then((response) => {
                return response.data
            })
    },

    getDeviceGroup({ id } = {}) {
        return api
            .get('/device/GetDeviceGroup?id=' + id)
            .then((response) => {
                return response.data
            })
    },
	
    countMessages({ modemIdentifier, page, perPage, start, end } = {}) {
        return api
            .get('/device/countmessages?modemIdentifier=' + modemIdentifier + '&page=' + page + '&perPage=' + perPage + '&start=' + start + '&end=' + end)
            .then((response) => {
                return response.data
            })
    },
    exportCountMessageExcel({ modemIdentifier, page, perPage, start, end } = {}) {
        return api
            .get('/device/ExportCountMessageExcel', {
                params: {
                    modemIdentifier,
                    page,
                    perPage,
                    start,
                    end
                },
                responseType: 'blob'
            })
            .then((response) => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Count Messages report.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();

                return true;
            })
    },
    searchHistory({ deviceId, page } = {}) {
        return api
            .get(`Device/history/search?Id=${deviceId}&Page=${page}&PerPage=15`)
            .then((response) => {
                return response.data
            })
    },
    createRequest({ deviceId } = {}) {
        return api
            .post('/Device/requestplandeactivation/create', { deviceId: deviceId, note:'' }, {})
            .then((response) => {
                return response.data
            })
    },
    closeRequest({ id } = {}) {
        return api
            .post('/Device/requestplandeactivation/setclose', { id: id }, {})
            .then((response) => {
                return response.data
            })
    },
    searchPlanDeactivation({ modemIdentifier, page, perPage, status } = {}) {
        return api
            .get(`/Device/requestplandeactivation/search?ModemIdentifier=${modemIdentifier}&Status=${status}&Page=${page}&PerPage=${perPage}`)
            .then((response) => {
                return response.data
            })
    },
    searchSupplierPlan() {
        return api
            .get(`/Plan/search`)
            .then((response) => {
                return response.data
            })
    },
    searchAllConfigurationBrand() {
        return api
            .get('/device/searchallinstallconfigurationbrand')
            .then((response) => {
                return response.data
            })
    },
    searchConfigurationModels({ brandId } = {}) {
        const brand = brandId ? brandId : ''
        return api
            .get('Device/searchallinstallconfigurationmodel?BrandId=' + brand)
            .then((response) => {
                return response.data
            })
    },

    fetchActivateTestPlan({ deviceId } = {}) {
        return api
            .get('/plan/ActivateTestPlan?deviceId=' + deviceId)
            .then((response) => {
                return response.data
            })
    },

    fetchActivateSafeLinkPlan({ deviceId } = {}) {
        return api
            .get('/plan/ActivateSafeLinkPlan?deviceId=' + deviceId)
            .then((response) => {
                return response.data
            })
    },
    
    

}
